export default __webpack_public_path__ + "static/media/GR00005-pen_line.61635a3f.svg";